import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Users } from 'lucide-react';
import Navbar from '../components/Navbar';
import SEO from '../components/SEO';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AboutUs = () => {
  const navigate = useNavigate();
  const [dynamicContent, setDynamicContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/site-content/about-us`)
      .then(res => { if (res.data.content) setDynamicContent(res.data.content); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-white pt-16">
      <SEO title="About Us" description="PropTick is Kerala's premier property discovery platform. We connect buyers, sellers, and investors with verified premium properties." path="/about-us" />
      <Navbar />

      <div className="px-6 md:px-12 lg:px-24 pt-6">
        <div className="max-w-3xl mx-auto">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-slate-500 hover:text-slate-900 transition-colors text-sm font-medium"
            data-testid="back-from-about"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </button>
        </div>
      </div>

      <article className="px-6 md:px-12 lg:px-24 py-8">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 rounded-xl bg-blue-600 flex items-center justify-center">
              <Users className="w-6 h-6 text-white" />
            </div>
            <div>
              <h1 className="text-3xl sm:text-4xl font-bold text-slate-900" data-testid="about-title">About Us</h1>
              <p className="text-slate-500 text-sm">PROPTICK</p>
            </div>
          </div>

          <div className="border-t border-slate-100 pt-8">
            {loading ? (
              <div className="flex items-center justify-center py-12">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
              </div>
            ) : (
              <div className="text-slate-700 leading-relaxed text-base">
                {(dynamicContent || defaultContent).split('\n').map((line, i) => {
                  const trimmed = line.trim();
                  if (!trimmed) return null;
                  return <p key={i} className="mb-4">{trimmed}</p>;
                })}
              </div>
            )}
          </div>
        </div>
      </article>
    </div>
  );
};

const defaultContent = `At PropTick, we're building a trust-first real estate platform designed for modern buyers, especially NRIs navigating property decisions from afar.

Having experienced the challenges firsthand, we understand how fragmented, cluttered, and unreliable the current ecosystem can be. From irrelevant listings to lack of verified information, today's solutions often create more confusion than clarity.

We believe the problem isn't demand, it's trust.

That's why PropTick focuses on verified properties, and a user-first experience. Our goal is to simplify property discovery, remove guesswork, and enable confident, remote decision-making - no noise, no shortcuts, just clarity.`;

export default AboutUs;
